<template>
  <footer class="has-background-grey-darker container" style="padding: 2rem;">
    <div class="columns">
      <div class="column is-3 has-text-white is-size-7">
        <img src="../assets/logo-white.png" style="height: 3rem;" />
        <p>
          Get in touch with us at support@sidesearch.com
        </p>
        <p style="margin-top: 1rem;">Proudly built in Florida</p>
      </div>
      <div class="column is-3">
        <div v-for="link in footerLinks" :key="link.label">
          <router-link v-if="!link.isExternal" :to="link.href" class="has-text-white">
            {{ link.label }}
          </router-link>
          <a v-else :href="link.href" class="has-text-white">
            {{ link.label }}
          </a>
        </div>
      </div>
      <div class="column is-6 has-text-right">
        <button class="button is-primary is-rounded">
          Log In
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',

  data () {
    return {
      footerLinks: [
        { label: 'Get Support', href: 'https://www.sidesearch.com/contact', isExternal: true },
        { label: 'Contact Us', href: 'https://www.sidesearch.com/contact', isExternal: true },
        { label: 'SideSearch Agency', href: 'https://www.sidesearch.com/agency', isExternal: true },
        { label: 'Create a Profile', href: '/sign-up/candidate', isExternal: false },
        { label: 'Find Candidates', href: 'sign-up/company', isExternal: false },
        { label: 'FAQ', href: 'https://www.sidesearch.com/faq', isExternal: true }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
